<template>
<div>
  <el-row type="flex" justify="space-between" class="title-bar">
    <w-perf-analysis-time-info :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataLoad" />
  </el-row>
  <div class="flow-agent-wrapp" v-for="(item, index) in flowList" :key="`${item.agentName}${item.ipaddress}`">
    <div class="txt-area">
      <div class="tit">Agent #{{getIndexCount(index+1)}}</div>
      <strong class="txt-line">
        {{item.agentName}} {{`(${item.ipaddress})`}}<br>
        {{item.url}}
      </strong>
    </div>
    <div class="flow-agent-list">
      <div class="img">
        <img src="@/assets/img/agent_flow01.png" alt="">
      </div>
      <div class="flow-agent-arrow">
        <div class="data">
          <div class="data-txt">
            도메인 / IP 조회 <br>
            <strong>{{item.nameLookup}} ms</strong>
          </div>
          <div class="left"></div>
          <div class="right"></div>
        </div>
      </div>
      <div class="img">
        <img src="@/assets/img/agent_flow02.png" alt="">
      </div>
      <div class="flow-agent-arrow">
        <div class="data">
          <div class="data-txt">
            원격 호스트 연결 <br>
            <strong>{{item.hostServerConn}} ms</strong>
          </div>
          <div class="left"></div>
          <div class="right"></div>

          <div class="data-txt data-graph">
            <div>
              파일 전송<br>
              <strong> {{item.fileTransfer}} ms</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="img">
        <img src="@/assets/img/agent_flow03.png" alt="">
      </div>
      <div class="flow-agent-arrow">
        <div class="data">
          <div class="data-txt">
            서비스 대기<br>
            <strong>{{item.serviceWait}} ms</strong>
          </div>
          <div class="left"></div>
          <div class="right"></div>
        </div>
      </div>
      <div class="img">
        <img src="@/assets/img/agent_flow04.png" alt="">
      </div>
      <div class="flow-agent-arrow">
        <div class="data">
          <div class="data-txt">
            DB 접근<br>
            <strong>{{item.dbService}} ms</strong>
          </div>
          <div class="left"></div>
          <div class="right"></div>
        </div>
      </div>
      <div class="img">
        <img src="@/assets/img/agent_flow05.png" alt="">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WE2EFlowMap',
  components: {
    WPerfAnalysisTimeInfo,
  },
  props: {
    flowData: {
      type: Object,
    },
  },
  data() {
    return {
      flowList: null,
      checkDatetime: null,
    };
  },
  watch: {
    flowData: {
      handler(flowData) {
        if (isEmpty(flowData)) {
          this.flowList = [];
          this.checkDatetime = null;
        } else {
          this.flowList = isEmpty(flowData.snapshotDoc) ? [] : flowData.snapshotDoc;
          this.checkDatetime = flowData.timestamp;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getIndexCount(value) {
      if (value < 10) {
        return `0${value}`;
      }
      return value;
    },
    onTimeTypeChange(value) {
      this.$emit('time-type-change', value);
    },
    onCurrentDataLoad() {
      this.$emit('reload');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/e2e/components/E2EFlowMap.vue